import {type Module} from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

// state
const state: ModuleInstallerState = {
    fetch: null,
    isFetched: false,
    hasDeletePrivilege: false,
    servers: {},
    versions: [],
};

// module
const installer: Module<ModuleInstallerState, RootState> = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};

export default installer;